import { useEffect, useState } from 'react';

const QUERY = '(prefers-color-scheme: dark)';

/**
 * Whether the OS / browser is asking for a dark colour scheme. Tracks changes
 * live, so flipping the system setting re-renders subscribers. Same shape as
 * useIsMobile; SSR and test environments without matchMedia read as light.
 */
const usePrefersDark = () => {
  const [prefersDark, setPrefersDark] = useState(
    () => typeof window === 'object'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window !== 'object' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mediaQueryList = window.matchMedia(QUERY);
    const handleChange = (e) => setPrefersDark(e.matches);
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange);
    } else {
      mediaQueryList.addListener(handleChange);
    }
    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', handleChange);
      } else {
        mediaQueryList.removeListener(handleChange);
      }
    };
  }, []);

  return prefersDark;
};

export default usePrefersDark;
